// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"BreadCrumb_breadcrumbs__ULrOW"};